export const FUNDING_PROVIDER_MEMO_OPEN = '@type/FUNDING_PROVIDER_MEMO_OPEN';
export const FUNDING_PROVIDER_MEMO_CLOSE = '@type/FUNDING_PROVIDER_MEMO_CLOSE';
